import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import { ProfileSectionTool } from '../../../../viewer/tools/profile-section-tool';
import { reset } from '../../../utils/styled-reset';
import { ProfileSectionToolMenu } from '../../skyview-new/components/profile-section-tool-menu/profile-section-tool-menu';
import { SkyviewContext } from '../skyview-state';

const bottomMenuHeight = 700;

type Props = {
  className?: string;
};

export const BottomMenuAutoExpandContainer = (props: Props) => {
  const { activeTool } = React.useContext(SkyviewContext);

  const content = useMemo(() => {
    if (activeTool instanceof ProfileSectionTool) {
      return <ProfileSectionToolMenu tool={activeTool} />;
    }

    return undefined;
  }, [activeTool]);
  const expanded = content !== undefined;

  return (
    <Component className={props.className} data-expanded={expanded}>
      <Content data-expanded={expanded}>{content}</Content>
    </Component>
  );
};

const Component = styled.div.attrs<{ 'data-expanded': boolean }>((props) => ({
  style: {
    height: props['data-expanded'] ? `${bottomMenuHeight}px` : '0px',
  },
}))`
  ${reset}

  position: relative;
  overflow-x: auto;
  overflow-y: hidden;

  width: 100%;
  max-height: max(35%, 300px);
  background-color: white;
  transition: height 0.5s ease-in-out;
  border-left: solid 1px ${(props) => props.theme.color.gray.light};
  border-right: solid 1px ${(props) => props.theme.color.gray.light};
`;

const Content = styled.div<{ 'data-expanded': boolean }>`
  position: relative;
  height: 100%;
  width: 100%;
  overflow-x: hidden;

  > * {
    transition: 0s visibility;
    visibility: hidden;
    height: 100%;
    width: 100%;

    ${(props) =>
      props['data-expanded'] &&
      css`
        visibility: visible;
        transition-delay: 0.1s;
      `}
  }
`;
